import { render, staticRenderFns } from "./OJTSnippet.vue?vue&type=template&id=34f88645"
import script from "./OJTSnippet.vue?vue&type=script&lang=js"
export * from "./OJTSnippet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports